import * as types from "../constants/ActionTypes";
import { RefreshNoAnswerCall } from "../actions/websocket";
import Moment from "moment";

const listcallqueue = (state = [], action) => {
  switch (action.type) {
    case types.LIST_QUEUE:
      return action.callqueue.map((queue) => {
        return queue;
      });

    case types.ADD_QUEUE:
      var existeQueue = false;
      state.map((queue) => {
        if (parseInt(queue.queueid) === parseInt(action.callqueueid))
          existeQueue = true;
      });

      if (!existeQueue) {
        return [
          {
            queueid: action.callqueueid,
            caller: action.chamador,
            called: action.chamado,
            to_char: action.datahora,
            recv_count: action.contrech,
            status: action.status,
            mediaid: action.mediaid,
            cdrid: action.cdrid,
            scriptid: action.scriptid,
            callback_count: action.callback_count,
            customerwait: action.customerwait,
            contactname: action.contactname,
            serviceinid: action.serviceinid,
            pathfile: action.pathfile,
            score_class: action.score_class,
            score_value: action.score_value,
          },
          ...state,
        ];
      } else {
        return state
      }

      return state;
      break;

    case types.EDIT_QUEUE:
      return state.map((queue) => {
        if (parseInt(queue.queueid) === parseInt(action.callqueueid)) {
          return {
            ...queue,
            queueid: action.callqueueid,
            caller: action.chamador,
            called: action.chamado,
            to_char: action.datahora,
            recv_count: action.contrech,
            status: action.status,
            mediaid: action.mediaid,
            cdrid: action.cdrid,
            customerwait: action.customerwait,
            serviceinid: action.serviceinid,
            anyreturn: action.anyreturn,
            pathfile: action.pathfile,
            score_class: action.score_class,
            score_value: action.score_value,
          };
        }
        return queue;
      });

    case types.RETURN_QUEUE:
      return state.map((queue) => {
        if (parseInt(queue.queueid) === parseInt(action.callqueueid)) {
          return {
            ...queue,
            status: action.status,
            callback_count: action.callback_count,
            username: action.username,
          };
        }
        return queue;
      });

    case types.RETURN_QUEUEOBS:
      return state.map((queue) => {
        if (parseInt(queue.queueid) === parseInt(action.callqueueid)) {
          return {
            ...queue,
            status: action.status,
            obs:
              queue.obs !== null
                ? queue.obs +
                  Moment().format("DD/MM/YYYY HH:mm:ss") +
                  "-" +
                  action.anyreturn
                : Moment().format("DD/MM/YYYY HH:mm:ss") +
                  "-" +
                  action.anyreturn,
          };
        }
        return queue;
      });

    case types.REFRESH_QUEUE_STATUS:
      return state.map((queue) => {
        if (parseInt(queue.cdrnew) === parseInt(action.cdrid)) {
          return { ...queue, status: "0" };
        }
        return queue;
      });

    case types.REFRESH_QUEUE_ID:
      return state.map((queue) => {
        if (parseInt(queue.queueid) === parseInt(action.queueid)) {
          return { ...queue, cdrnew: action.cdrnew };
        }
        return queue;
      });

    case types.DELETE_QUEUE:
      return state.filter(
        (todo) => parseInt(todo.queueid) !== parseInt(action.callqueueid)
      );

    case types.EDIT_CALLBACK:
      if (state) {
        return state.map((cback) => {
          if (parseInt(action.caller) === parseInt(cback.caller)) {
            return { ...cback, respclient: action.respclient };
          }
          return cback;
        });
      }
      break;

    case types.RESP_ATD:
      if (state) {
        return state.map((cback) => {
          if (parseInt(action.caller) === parseInt(cback.caller)) {
            return { ...cback, respatendente: action.respatendente };
          }
          return cback;
        });
      }
      break;

    case types.CLEAR_RETURN:
      if (state) {
        return state.map((cback) => {
          if (parseInt(action.caller) === parseInt(cback.caller)) {
            return { ...cback, status: action.status };
          }
          return cback;
        });
      }
      break;

    case types.REFRESH_NO_ANSWER:
      return state.map((queue) => {
        if (parseInt(queue.queueid) === parseInt(action.queueid)) {
          return { ...queue, status: "0" };
        }
        return queue;
      });

    default:
      return state;
  }
};

export default listcallqueue;
